import { createSlice, createSelector } from '@reduxjs/toolkit';

const profileTypesSlice = createSlice({
  name: 'profileTypes',
  initialState: [],
  reducers: {
    setProfileTypes(draft, action) {
      return action.payload;
    },

    addProfileType(draft, action) {
      draft.push(action.payload);
    },

    updateProfileType(draft, action) {
      const profileTypeIndex = draft.findIndex(
        (p) => p.profileTypeId === action.payload.profileTypeId,
      );

      if (profileTypeIndex !== -1) {
        // eslint-disable-next-line no-param-reassign
        draft[profileTypeIndex] = { ...draft[profileTypeIndex], ...action.payload };
      }
    },

    removeProfileType(draft, action) {
      const profileTypeIndex = draft.findIndex((p) => p.profileTypeId === action.payload);

      if (profileTypeIndex !== -1) {
        draft.splice(profileTypeIndex, 1);
      }
    },
  },
});

export const { addProfileType, removeProfileType, setProfileTypes, updateProfileType } =
  profileTypesSlice.actions;

export default profileTypesSlice.reducer;

export const profileTypesSelector = (state) => state.profileTypes;

export const profileTypeSelector = createSelector(
  [profileTypesSelector, (s, id) => id],
  (profileTypes, id) => profileTypes.find((p) => p.profileTypeId === id),
);

export const isProfileTypesEmptySelector = createSelector(
  profileTypesSelector,
  (p) => p.length === 0,
);
